/*@ngInject*/
const ChatNotificationModel = function (coreConstant) {

    let notifications = [],
        notificationsPopulated = false,
        selectedFilter = coreConstant.chatNotifications.filters.ALL;

    this.areNotificationsPopulated = function () {
        return notificationsPopulated;
    };

    this.prependNotification = function (notification) {
        _.remove(notifications, function (existingNotification) {
            return existingNotification.submissionId === notification.submissionId;
        });
        notifications.unshift(notification);
    };

    this.removeNotification = function (notificationToRemove) {
        _.remove(notifications, function (notification) {
            return notification.id === notificationToRemove.id;
        });
    };

    this.updateNotification = function (notification) {
        let arrayLength = notifications.length;
        for (let i = 0; i < arrayLength; i++) {
            if (notifications[i].id === notification.id) {
                notifications[i] = notification;
            }
        }
    };

    this.getNotifications = function () {
        return notifications;
    };

    this.clearNotifications = function () {
        notifications = [];
        notificationsPopulated = false;
    };

    this.setNotifications = function (newNotifications) {
        notifications = newNotifications;
        notificationsPopulated = true;
    };

    this.setSelectedFilter = function (filter) {
        selectedFilter = filter;
    };

    this.getSelectedFilter = function () {
        return selectedFilter;
    };
};

angular.module('ums')
    .service('chatNotificationModel', ChatNotificationModel);
